<template>
  <div class="wrapper">
     <div class="pull-list">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div v-for="(item, id) in staffList" :key="id">
            <div class="stuff">
              <div class="icon">{{item.realName ? item.realName.slice(-2) : '' }}</div>
              <div class="name">
                <p>
                  {{item.realName}} {{item.innerFlag === 2 ? '(管理员)' : ''}}
                </p>
                <p v-if="showPhone">
                  {{item.phone}}
                </p>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { accountRequest } from '@services'
import {
  List,
  PullRefresh,
  Notify
} from 'vant'
export default {
  components: {
    [List.name]: List,
    [Notify.name]: Notify,
    [PullRefresh.name]: PullRefresh
  },
  props: {},
  data () {
    return {
      refreshing: false,
      loading: false,
      finished: false,
      staffList: [],
      searchParams: {
        size: 25,
        current: 1,
        valid: 0
      },
      showPhone: false
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {
    this.setRole()
    this.getStaffList()
  },
  activated () {},
  updated () {},
  methods: {
    setRole () {
      if (this.$store.state.user && this.$store.state.user.userInfo.innerFlag === 2) {
        this.showPhone = true
      } else {
        this.showPhone = false
      }
    },
    async getStaffList () {
      if (this.refreshing) {
        this.refreshing = false
      }
      this.loading = true
      const data = await accountRequest.company.getStaffList(this.searchParams)
      if (data.success) {
        if (data.result.records) {
          this.staffList = [...this.staffList, ...data.result.records]
          if (Number(data.result.size) > data.result.records.length) {
            this.finished = true
          } else {
            this.finished = false
          }
        } else {
          this.finished = true
        }
      } else {
        this.finished = true
        Notify({ type: 'danger', message: data.message })
      }
      this.loading = false
    },
    onRefresh () {
      this.finished = false
      this.searchParams.current = 1
      this.staffList = []
      this.getStaffList()
    },
    onLoad () {
      this.searchParams.current++
      this.getStaffList()
    }
  }
}
</script>
<style lang="less" scoped src="./style.less"/>
